module.exports = __webpack_public_path__ + "static/media/profile-img.ecc39fd8.jpg";